import { createContext, useContext } from 'react';
import type { ToolStepPart } from '@/entities/ai';

/**
 * Renames one tool step, from what the call streamed about itself. Undefined keeps the tool's own
 * name. A conversation whose tools are better described by their effect than by their name (the
 * Copilot's canvas edits) provides one around its chat.
 */
export type ToolStepTitle = (step: {
  callId: string;
  parts: readonly ToolStepPart[];
}) => string | undefined;

const ToolStepTitleContext = createContext<ToolStepTitle | undefined>(undefined);

export const ToolStepTitleProvider = ToolStepTitleContext.Provider;

export const useToolStepTitle = (): ToolStepTitle | undefined => useContext(ToolStepTitleContext);
